import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Dealer, OrderLineDetail } from 'app/core/model/entity-model';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-report-open-orders',
    templateUrl: './report-open-orders.component.html',
    styleUrls: ['./report-open-orders.component.scss'],
    standalone: false
})
export class ReportOpenOrdersComponent implements OnInit {
    router = inject(Router);
    orderLineDetails: any[];
    dealers: Dealer[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private modalService: BsModalService, public auth: AuthService) {}

    async ngOnInit() {
        this.dealers = (await this.uow.dealers.all()) as Dealer[];
        await this.getData();
    }

    async getData() {
        this.orderLineDetails = (await this.uow.getOrderBuildDetail(['orderLine.order.achPayments', 'optionDetails.orderLine', 'invoice'],false,true)) as OrderLineDetail[];
        this.orderLineDetails.forEach((detail) => {
            detail.trailerPrice = detail.orderLine.paidAch ? detail.quantity * detail.orderLine.achLineAmount : detail.quantity * detail.orderLine.price;
            let rowNote = '';
            detail.optionsTotalPrice = 0;
            if (!!detail.optionDetails) {
                _.sortBy(detail.optionDetails, 'orderLine.partNumber').forEach((option) => {
                    let optionPrice: number = 0;
                    let optionPriceDisplay: number = 0;
                    optionPriceDisplay = option.orderLine.paidAch ? option.quantity * option.orderLine.achLineAmount : option.quantity * option.orderLine.price;
                    if (!option.deleted) {
                        optionPrice = optionPriceDisplay;
                    }
                    const dateDiff = moment.duration(moment(option.created).diff(moment(detail.created))).asSeconds();
                    let addedOption = false;
                    if (dateDiff > 60) addedOption = true;

                    rowNote += `${addedOption ? '<b><font color="green">' : ''}${option.deleted ? '<s><font color="red">' : ''}${
                        option
                            ? `${option.orderLine.partNumber} ${optionPriceDisplay.toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD',
                              })}`
                            : ''
                    }${option.deleted ? '</s></font color="red">' : ''}${addedOption ? '</b></font color="green">' : ''}<br>`;

                    detail.optionsTotalPrice += optionPrice;
                });
            }
            detail.totalPrice = detail.trailerPrice + detail.optionsTotalPrice;
            detail.hasInvoice = !!detail.invoiceId;
            detail.hasInvoiceInQB = !!detail.invoiceId && !!detail.invoice.quickBooksId;
            return (detail.optionHTML = `${rowNote}`);
        });
    }

    async rowPrepare(e) {
        if (e.rowType === 'data' && !!e.data.orderLine && !!e.data.orderLine.order && !!e.data.orderLine.order.dealer) {
            if (e.data.orderLine.order.dealer.colorCode !== null) {
                e.rowElement.className = e.rowElement.className + ` ${e.data.orderLine.order.dealer.colorCode}-line`;
            }
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        if (!orderId) return;
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.orderLine.orderId) return;
        await this.open(e.data.orderLine.orderId);
    }

    async openInvoice(invoiceId: number) {
        this.router.navigate([`invoices/${invoiceId}`]);
    }
}
